export default __webpack_public_path__ + "static/logo-9a8f7d61e6c7d880e4b4a3417d6a9b37.svg";